<template>
  <div>
    <div class="panel panel-primary student-view__panel-personal-data">
      <div class="panel-body">
        <div class="student-data__component">
          <div class="student-view__header-title">
            <h4>
              <strong>Documentos</strong>
            </h4>
          </div>
          <hr class="divider divider--spaced-l-bottom">
          <div v-for="(owner, ownerIndex) in owners" :key="ownerIndex" class="documents-row">
            <document
              v-for="(document, documentIndex) in documents[owner].documents"
              :owner="owner"
              :translated-owner="documents[owner].translatedOwner"
              :document="document"
              :can-upload-or-destroy-document="canUploadOrDestroyDocument"
              :key="`${owner}${documentIndex}`"
              @document-selected="selectDocument(document, documents[owner])"
            />
          </div>

          <div v-if="canApproveDocuments && !isDigitalEnrollmentPlan" class="row">
            <div class="col-xs-12 text-right">
              <button
                @click="finishDocumentsUpdate()"
                class="btn btn-primary"
              >
                Salvar Alterações
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <course-confirmation-modal
      :parcelamento-course="course"
      :payment-plan="paymentPlan"
      :courses="courses"
      v-if="showCourseConfirmationModal"
      @close="showCourseConfirmationModal = false"
      @selectCourse="selectCourse"
      @finish="updateDocuments"
    />

    <approve-document-modal
      v-if="showApproveDocumentModal"
      :owner="selectedEntity.owner"
      :translated-owner="selectedEntity.translatedOwner"
      :document="selectedDocument"
      :reprovation-reasons="reprovationReasons"
      @close="showApproveDocumentModal = false"
      @approved="approveDocument"
      @reproved="reproveDocument"
    />

    <upload-document-modal
      v-if="showUploadDocumentModal"
      :owner="selectedEntity.owner"
      :translated-owner="selectedEntity.translatedOwner"
      :document="selectedDocument"
      :payment-plan="paymentPlan"
      @close="showUploadDocumentModal = false"
      @change="updateDocument($event)"
    />
  </div>
</template>
<style lang="scss" scoped>
  .documents-row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;
    flex-direction: row;
  }
</style>
<script>
import Document from 'pages/Parcelamento/StudentView/PaymentPlanData/Document';
import ApproveDocumentModal from 'pages/Parcelamento/StudentView/PaymentPlanData/ApproveDocumentModal';
import UploadDocumentModal from 'pages/Parcelamento/StudentView/PaymentPlanData/UploadDocumentModal';
import ParcelamentoService from 'services/ParcelamentoService';
import CourseConfirmationModal from 'pages/Parcelamento/StudentView/PaymentPlanData/CourseConfirmationModal';

export default {
  components: {
    Document,
    ApproveDocumentModal,
    UploadDocumentModal,
    CourseConfirmationModal,
  },
  props: {
    paymentPlan: {
      type: Object,
      default: () => {},
    },
    course: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      documentsEvaluated: false,
      showApproveDocumentModal: false,
      showCourseConfirmationModal: false,
      showUploadDocumentModal: false,
      selectedDocument: null,
      selectedEntity: null,
      reprovationReasons: [],
      selectedQueroPagoCourse: null,
      documentsToUpdate: null,
      courses: [],
    };
  },
  computed: {
    owners() {
      return Object.keys(this.paymentPlan.documents);
    },
    documents() {
      return this.paymentPlan.documents;
    },
    canApproveDocuments() {
      return this.paymentPlan.status === 'documents_in_analysis' && !this.documentsEvaluated;
    },
    canUploadOrDestroyDocument() {
      return (
        (this.paymentPlan.planType === 'installment' && this.paymentPlan.status === 'data_completed')
        || this.paymentPlan.status === 'documents_reproved'
        || this.paymentPlan.status === 'exam_approved'
      );
    },
    isDigitalEnrollmentPlan() {
      return this.paymentPlan.planType === 'digital_enrollment';
    },
  },
  mounted() {
    this.loadQueroPagoCourses();
    this.$loader.show();
    ParcelamentoService.getDocumentReprovationReason()
      .then((data) => {
        this.reprovationReasons = data;
      })
      .catch(() => {
        this.$alert.notifyAlert('Erro ao buscar motivos de reprovação.');
      })
      .finally(() => {
        this.$loader.hide();
      });
  },
  methods: {
    loadQueroPagoCourses() {
      if (!this.paymentPlan.qpStudentId) {
        return;
      }

      this.$loader.show();
      ParcelamentoService.getQueroPagoCourses(this.paymentPlan.qpStudentId).then((response) => {
        this.courses = response;
      }).finally(() => {
        this.$loader.hide();
      });
    },
    allDocumentsApproved() {
      let documentsApproved = true;
      Object.keys(this.documents).forEach((owner) => {
        this.documents[owner].documents.forEach((document) => {
          if (document.status === 'reproved') {
            documentsApproved = false;
          }
        });
      });

      return documentsApproved;
    },
    allDocumentsSent() {
      let documentsInAnalysis = true;
      Object.keys(this.documents).forEach((owner) => {
        this.documents[owner].documents.forEach((document) => {
          if (document.status !== 'sent' && document.status !== 'approved') {
            documentsInAnalysis = false;
          }
        });
      });

      return documentsInAnalysis;
    },
    finishDocumentsUpdate() {
      if (this.paymentPlan.currentQpCourseId || this.courses.length === 0) {
        this.updateDocuments();
      } else {
        this.openCourseConfirmationModal();
      }
    },
    openCourseConfirmationModal() {
      this.documentsToUpdate = this.getDocumentsToUpdate();
      if (this.documentsToUpdate) {
        this.showCourseConfirmationModal = true;
      }
    },
    selectCourse(selectedCourse) {
      this.selectedQueroPagoCourse = selectedCourse;
    },
    approveDocument() {
      this.showApproveDocumentModal = false;
      this.selectedDocument.translatedStatus = 'Aprovado';
      this.selectedDocument.newStatus = 'approved';
      this.selectedDocument.status = 'approved';
      this.selectedDocument.reprovationReason = null;
    },
    reproveDocument(reprovationReason) {
      this.showApproveDocumentModal = false;
      this.selectedDocument.translatedStatus = 'Reprovado';
      this.selectedDocument.newStatus = 'reproved';
      this.selectedDocument.status = 'reproved';
      this.selectedDocument.reprovationReason = reprovationReason;
    },
    clearNewStatus() {
      Object.keys(this.documents).forEach((owner) => {
        this.documents[owner].documents.forEach((document) => {
          // eslint-disable-next-line no-param-reassign
          delete document.newStatus;
        });
      });
    },
    getDocumentsToUpdate() {
      if (this.canApproveDocuments) {
        let canUpdate = true;
        const documentsToUpdate = [];
        Object.keys(this.documents).forEach((owner) => {
          this.documents[owner].documents.forEach((document) => {
            if (document.status !== 'approved' && document.status !== 'reproved') {
              canUpdate = false;
            }

            if (document.newStatus) {
              documentsToUpdate.push({
                id: document.id,
                status: document.newStatus,
                reprovation_reason: document.reprovationReason,
              });
            }
          });
        });

        if (!canUpdate) {
          this.$alert.notifyAlert('Avalie todos os documentos antes de prosseguir.');
          return false;
        } if (documentsToUpdate.length === 0) {
          this.$alert.notifyAlert('Todos os documentos já foram avaliados.');
          return false;
        }
        return documentsToUpdate;
      }
      return false;
    },
    updateDocuments() {
      this.showCourseConfirmationModal = false;
      this.documentsToUpdate = this.getDocumentsToUpdate();

      if (this.documentsToUpdate) {
        this.$loader.show();
        ParcelamentoService.updateDocuments(this.paymentPlan.id, this.documentsToUpdate, this.selectedQueroPagoCourse)
          .then(() => {
            this.$alert.notifySuccess('Documentos atualizados com sucesso.');
            this.clearNewStatus();
            this.documentsEvaluated = true;
            if (this.allDocumentsApproved()) {
              this.$emit(
                'documents-approved',
                { status: 'documents_approved', translatedStatus: 'Documentação aprovada' },
              );
            } else {
              this.$emit(
                'documents-reproved',
                { status: 'documents_reproved', translatedStatus: 'Documentação reprovada' },
              );
            }
          })
          .catch(() => {
            this.$alert.notifyAlert('Erro ao atualizar status dos documentos.');
          })
          .finally(() => {
            this.$loader.hide();
          });
      }
    },
    updateDocument(document) {
      this.$set(this.selectedDocument, 'id', document.id);
      this.$set(this.selectedDocument, 'attachments', document.attachments);
      this.$set(this.selectedDocument, 'status', document.status);
      this.$set(this.selectedDocument, 'translatedStatus', document.translatedStatus);
      this.documentsEvaluated = false;

      if (this.allDocumentsSent()) {
        this.$emit(
          'documents-in-analysis',
          { status: 'documents_in_analysis', translatedStatus: 'Documentação enviada' },
        );
      }
    },
    selectDocument(document, documentEntity) {
      if (document.status === 'approved') return;

      this.selectedDocument = document;
      this.selectedEntity = documentEntity;

      if (document.status === 'sent' && !this.isDigitalEnrollmentPlan) {
        this.showApproveDocumentModal = true;
      } else if (this.canUploadOrDestroyDocument) {
        this.showUploadDocumentModal = true;
      } else {
        this.$alert.notifyAlert('Não é possivel alterar este documento, ação do aluno ou da IES necessária.');
      }
    },
  },
};
</script>
